import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <Section data-id="element-13">
      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-14">
        {/* Who it's for */}
        <div className="bg-tactical-surface border border-tactical-cyan/30 rounded-2xl p-8 relative overflow-hidden" data-id="element-15">
          <div className="absolute top-0 right-0 w-32 h-32 bg-tactical-cyan/10 blur-[50px] rounded-full" data-id="element-16"></div>
          <h3 className="text-2xl mb-6 flex items-center gap-3" data-id="element-17">
            <div className="w-8 h-8 rounded-full bg-tactical-cyan/20 flex items-center justify-center" data-id="element-18">
              <Check className="w-5 h-5 text-tactical-cyan" data-id="element-19" />
            </div>
            WHO THIS IS FOR
          </h3>
          <ul className="space-y-4 font-inter text-slate-300" data-id="element-20">
            <li className="flex items-start gap-3" data-id="element-21">
              <div className="w-1.5 h-1.5 rounded-full bg-tactical-cyan mt-2 shrink-0" data-id="element-22"></div>
              <span data-id="element-23">
                Parents of U10-U16 competitive, travel, or academy players.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-24">
              <div className="w-1.5 h-1.5 rounded-full bg-tactical-cyan mt-2 shrink-0" data-id="element-25"></div>
              <span data-id="element-26">
                Players who are technically skilled but struggle with "game IQ."
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-27">
              <div className="w-1.5 h-1.5 rounded-full bg-tactical-cyan mt-2 shrink-0" data-id="element-28"></div>
              <span data-id="element-29">
                High-performance parents who want to give their child an unfair
                mental advantage.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-30">
              <div className="w-1.5 h-1.5 rounded-full bg-tactical-cyan mt-2 shrink-0" data-id="element-31"></div>
              <span data-id="element-32">
                Strikers and midfielders who need to create more space in
                crowded boxes.
              </span>
            </li>
          </ul>
        </div>

        {/* Who it's not for */}
        <div className="bg-tactical-dark border border-tactical-surface2 rounded-2xl p-8" data-id="element-33">
          <h3 className="text-2xl mb-6 flex items-center gap-3 text-slate-400" data-id="element-34">
            <div className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center" data-id="element-35">
              <X className="w-5 h-5 text-slate-500" data-id="element-36" />
            </div>
            WHO THIS IS NOT FOR
          </h3>
          <ul className="space-y-4 font-inter text-slate-400" data-id="element-37">
            <li className="flex items-start gap-3" data-id="element-38">
              <div className="w-1.5 h-1.5 rounded-full bg-slate-600 mt-2 shrink-0" data-id="element-39"></div>
              <span data-id="element-40">
                Parents of recreational players who just play for fun.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-41">
              <div className="w-1.5 h-1.5 rounded-full bg-slate-600 mt-2 shrink-0" data-id="element-42"></div>
              <span data-id="element-43">
                People looking for basic dribbling or "how to kick" tutorials.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-44">
              <div className="w-1.5 h-1.5 rounded-full bg-slate-600 mt-2 shrink-0" data-id="element-45"></div>
              <span data-id="element-46">
                Anyone looking for a "magic pill" that doesn't require 10
                minutes of daily focus.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </Section>;
}